import { ICON_COLOR } from '@zep-us/zus/tokens';
import { LockFillIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils/tailwind.util';

/**
 * 썸네일 위 잠금 표시(반투명 원 + 자물쇠).
 *
 * 위치와 크기는 썸네일마다 달라 `className` 으로 받는다 — 목록 카드는 큰 화면에서 왼쪽 위로 붙고,
 * 폴더 수정 행은 썸네일이 작아 가운데에 작게 둔다.
 */
export const LockBadge = ({
  className,
  iconSize = 'md',
  iconClassName
}: {
  className?: string;
  iconSize?: '2xs' | 'sm' | 'md';
  iconClassName?: string;
}) => <div className={cn('absolute flex items-center justify-center', className)} data-sentry-component="LockBadge" data-sentry-source-file="LockBadge.tsx">
    <div className={'absolute inset-0 rounded-full bg-opacity-white-8 backdrop-blur-[2px]'} />
    <LockFillIcon size={iconSize} fill={ICON_COLOR.default} className={cn('z-10', iconClassName)} data-sentry-element="LockFillIcon" data-sentry-source-file="LockBadge.tsx" />
  </div>;